import { render, staticRenderFns } from "./MailgunList.vue?vue&type=template&id=186a1424&scoped=true"
import script from "./MailgunList.vue?vue&type=script&lang=js"
export * from "./MailgunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a1424",
  null
  
)

export default component.exports